var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurkiye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_7817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5086 9.80556L15.4932 11.1624L17.0877 10.6453L16.1016 12.0009L17.086 13.3577L15.492 12.8387L14.5059 14.1943L14.507 12.518L12.9129 11.999L14.5075 11.482L14.5086 9.80556Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8216 15.3913C9.94865 15.3913 8.43028 13.8729 8.43028 12C8.43028 10.1271 9.94865 8.60869 11.8216 8.60869C12.4056 8.60869 12.955 8.75639 13.4347 9.01632C12.6822 8.28028 11.6529 7.82607 10.5172 7.82607C8.21203 7.82607 6.34335 9.69478 6.34335 12C6.34335 14.3051 8.21207 16.1738 10.5172 16.1738C11.653 16.1738 12.6822 15.7196 13.4347 14.9836C12.955 15.2436 12.4056 15.3913 11.8216 15.3913Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_7817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurkiye);
export default __webpack_public_path__ + "static/media/turkiye.bfe6cfffb619f36841842f2e8c224643.svg";
export { ForwardRef as ReactComponent };